module.exports = __webpack_public_path__ + "img/Business Objects.dbdbc003.png";